import { FC, Suspense, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedLayout } from '@/components/ProtectedLayout/ProtectedLayout';
import { useAuthStore } from '@/stores/useAuthStore';
import { PageLoader } from '@/components/PageLoader/PageLoader';
import { Labels } from '@/shared/labels';
import {
  appPublicRoutes,
  feedChildRouteConfig,
  protectedLazyLeaves,
} from './config';
import { FeedPage } from './pages';
import {
  RoutePaths,
  getDefaultAuthedRoute,
  outfitsWithOutfitIdQuery,
} from '@/shared/routePaths';
import { renderRouteLeaves } from '@/shared/utils/routeUtils';
import { wardrobeRoutesBranch } from './wardrobe';

export const AppRouter: FC = () => {
  const user = useAuthStore(state => state.user);
  const isOnboarded = Boolean(user?.onboarded);

  const [startParam] = useState(() => {
    const tgParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
    if (tgParam) return tgParam;
    const urlOutfitId = new URLSearchParams(window.location.search).get(
      'outfitId'
    );
    return urlOutfitId ?? null;
  });

  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader label={Labels.common.loading} />}>
        <Routes>
          {renderRouteLeaves(appPublicRoutes)}
          <Route element={<ProtectedLayout isOnboarded={isOnboarded} />}>
            <Route
              path={RoutePaths.HOME}
              element={
                startParam ? (
                  <Navigate to={outfitsWithOutfitIdQuery(startParam)} replace />
                ) : (
                  <Navigate
                    to={getDefaultAuthedRoute(isOnboarded)}
                    replace
                  />
                )
              }
            />
            {renderRouteLeaves(protectedLazyLeaves)}
            {wardrobeRoutesBranch}
            <Route element={<FeedPage />}>
              {renderRouteLeaves(feedChildRouteConfig)}
            </Route>
          </Route>
          <Route
            path="*"
            element={
              user ? (
                <Navigate to={getDefaultAuthedRoute(isOnboarded)} replace />
              ) : (
                <Navigate to={RoutePaths.AUTH} replace />
              )
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
